import React, {useState} from 'react'
import {makeStyles} from '@material-ui/core/styles'
import {
    Box,
    CssBaseline,
    Button,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Typography,
} from '@material-ui/core'
import Close from '@material-ui/icons/Close'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import {connect} from 'react-redux'
import {dataActions} from '../../actions'
import CircularProgress from '@material-ui/core/CircularProgress'

// IMAGES
import noSearchResults from '../../images/cs-no-search-results.svg'

// using hook API
const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
    resultsBox: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minWidth: '350px',
        maxWidth: '425px',
        padding: '2% 3% 0 3%',
    },
    buttonbox: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    submitButton: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        margin: theme.spacing(3, 0, 2),
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        height: '2.625rem',
        textTransform: 'uppercase',
        width: '100%',
        '&:hover': {
            boxShadow: 'none',
            backgroundColor: '#00652A',
        },
    },
    inline: {
        display: 'inline',
    },
}))

const LookupResults = props => {
    const classes = useStyles()

    const [activeRow, setactiveRow] = useState('')

    const {
        token,
        lookupresult,
        occurrence,
        swipe,
        callbackfunction,
        fetchingLookupResults,
        handleClose,
        clearlookupresults,
        exactMatchFn,
        lookupEUIDPerson,
    } = props
    const {eventId, occurId} = occurrence

    const reviewResults =
        'We found multiple results. Ask the attendee their email and select the correct person.'

    const tooManyResults =
        'Lookup failed. We found too many results to display. Please include more information in your search and try again.'

    const noResults =
        "Lookup Failed. We couldn't find any results for that information, modify your search and try again."

    const handleBack = () => {
        callbackfunction('LookupHome')
        clearlookupresults()
    }

    const handleSubmit = (token, eventId, occurId, EMPLID) => {
        switch (exactMatchFn) {
            case 'swipe':
                swipe(token, eventId, occurId, EMPLID)
                break
            case 'addSwiper':
            case 'addUser':
            case 'addSuperadmin':
                lookupEUIDPerson(token, EMPLID)
                break
            default:
                break
        }
        handleClose()
    }

    return (
        <>
            <CssBaseline />
            <div className={classes.root}>
                {fetchingLookupResults ? (
                    <div className={classes.resultsBox}>
                        <CircularProgress
                            style={{
                                color: '#00853e',
                            }}
                            thickness={3}
                        />
                    </div>
                ) : (
                    <>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}
                        >
                            <IconButton onClick={handleBack}>
                                <ArrowBackIcon style={{color: '#000000'}} />
                                <Typography
                                    variant="body2"
                                    style={{
                                        color: '#707070',
                                        fontWeight: '700',
                                    }}
                                >
                                    {' '}
                                    GO BACK{' '}
                                </Typography>
                            </IconButton>
                            <IconButton onClick={handleClose}>
                                <Close style={{color: '#000000'}} />
                            </IconButton>
                        </div>
                        <Box className={classes.resultsBox}>
                            <Typography align="left" variant="h5">
                                Find by Name
                            </Typography>

                            {Array.isArray(lookupresult) &&
                            (lookupresult.length === 0 ||
                                lookupresult.length > 5) ? (
                                <Box align="center" style={{marginTop: '30px'}}>
                                    <img
                                        src={noSearchResults}
                                        alt="no search result"
                                        style={{width: '60%'}}
                                    />
                                    {lookupresult.length === 0 ? (
                                        <Typography
                                            variant="body1"
                                            style={{margin: '5px 0 15px 0'}}
                                        >
                                            {noResults}
                                        </Typography>
                                    ) : (
                                        <Typography
                                            variant="body1"
                                            style={{margin: '5px 0 15px 0'}}
                                        >
                                            {tooManyResults}
                                        </Typography>
                                    )}
                                </Box>
                            ) : (
                                Array.isArray(lookupresult) && (
                                    <>
                                        <Typography
                                            align="left"
                                            variant="body1"
                                        >
                                            {reviewResults}
                                        </Typography>

                                        <List
                                            style={{
                                                marginRight: '15px',
                                                maxHeight: '100%',
                                                overflow: 'auto',
                                            }}
                                        >
                                            {lookupresult.map(result => (
                                                <ListItem
                                                    button
                                                    key={result.emplid}
                                                    selected={
                                                        activeRow ===
                                                        result.emplid
                                                            ? true
                                                            : false
                                                    }
                                                    onClick={() =>
                                                        setactiveRow(
                                                            result.emplid
                                                        )
                                                    }
                                                >
                                                    <ListItemText
                                                        primary={
                                                            result.firstName +
                                                            ' ' +
                                                            (result.middleName
                                                                ? result.middleName +
                                                                  ' '
                                                                : null) +
                                                            result.lastName
                                                        }
                                                        primaryTypographyProps={{
                                                            variant: 'body1',
                                                            style: {
                                                                fontWeight:
                                                                    '700',
                                                            },
                                                        }}
                                                        secondary={
                                                            <React.Fragment>
                                                                <Typography
                                                                    component="span"
                                                                    variant="body2"
                                                                    className={
                                                                        classes.inline
                                                                    }
                                                                    color="textPrimary"
                                                                >
                                                                    {
                                                                        result.emailAddress
                                                                    }
                                                                </Typography>
                                                            </React.Fragment>
                                                        }
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>

                                        <Button
                                            type="button"
                                            variant="contained"
                                            size="medium"
                                            className={classes.submitButton}
                                            disabled={!activeRow}
                                            onClick={() =>
                                                handleSubmit(
                                                    token,
                                                    eventId,
                                                    occurId,
                                                    activeRow
                                                )
                                            }
                                        >
                                            Submit
                                        </Button>
                                    </>
                                )
                            )}
                        </Box>
                    </>
                )}
            </div>
        </>
    )
}

function mapStateToProps(state) {
    return {
        token: state.authentication.token,
        lookupresult: state.lookupdata.lookupresult,
        fetchingLookupResults: state.lookupdata.fetchingLookupResults,
        occurrence: state.occurrencedata.occurrence,
    }
}

const mapDispatchToProps = {
    clearlookupresults: () => dataActions.lookupClearResults(),
    swipe: (token, eventId, occurId, emplId) =>
        dataActions.swipeRequest(token, eventId, occurId, emplId),
    lookupEUIDPerson: (token, euid) =>
        dataActions.lookupEUIDRequest(token, euid),
}

export default connect(mapStateToProps, mapDispatchToProps)(LookupResults)
